import React from 'react';
import Modal from './ModalConversion';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSync } from '@fortawesome/free-solid-svg-icons';

export const ISBNModal = ({ isOpen, onClose, project, onSubmit, loading }) => {
    return (
        <Modal isOpen={isOpen} onClose={onClose}>
            <div className="p-3">
                <h3 className="mb-4 text-white">Gestionar ISBN</h3>
                {project && (
                    <div className="mb-3 p-2 bg-dark rounded border border-secondary text-white">
                        <p className="m-0"><strong>Proyecto:</strong> {project.account}-C-{project.ink_id}</p>
                        <p className="text-white-50 small m-0">{project.title}</p>
                    </div>
                )}
                <form onSubmit={onSubmit}>
                    <div className="form-group mb-3 text-start">
                        <label className="mb-1 fw-bold text-white">Número de ISBN</label>
                        <input 
                            type="text" 
                            name="isbn" 
                            className="form-control bg-dark text-white border-secondary py-2"
                            placeholder="Ej: 978-3-16-148410-0" 
                            defaultValue={project?.isbn_info?.isbn || ''}
                            required 
                        />
                    </div>
                    <div className="d-flex justify-content-end gap-2 mt-4">
                        <button type="button" className="btn btn-secondary" onClick={onClose}>Cancelar</button>
                        <button type="submit" className="btn btn-primary" disabled={loading}>
                            {loading ? (
                                <>
                                    <FontAwesomeIcon icon={faSync} spin className="me-2" />
                                    Guardando...
                                </>
                            ) : 'Guardar ISBN'}
                        </button>
                    </div>
                </form>
            </div>
        </Modal>
    );
};
